import React, { useState } from "react";
import topTranArrow from "../assets/topTranArrow.png";
import "./Post.css";
const Post = ({ text, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);
  console.log(open, defaultOpen);
  return (
    <div className=" bg-[#2A2D37] rounded-[10px] relative">
      <div className="flex justify-between">
        <button
          className={`
        text-[#2A2D37] font-bold   bg-main-green  rounded-tl-[10px] rounded-br-[10px]

        ${
          open
            ? "text-res-sm px-[19px] h-[50px]"
            : "text-res-xs px-[19px] h-[26px]"
        }
        
        `}
        >
          Bitcoin Rally this week
        </button>
        <h4
          className={`
          font-bold
        ${
          open
            ? "mt-[27px] mr-[30px] text-res-xs "
            : "mt-[14px] mr-[25px] text-[12px] "
        }
        `}
        >
          17th May, 2023
        </h4>
      </div>
      <div
        className={` tracking-[0.06em] whitespace-pre-wrap   leading-[24px]  break-words grid singlePostWrap ${
          open
            ? "open mt-[65px] text-[16px] px-[35px] pb-[74px] font-medium "
            : "mt-[18px] text-[14px] pb-10 pl-[37px] pr-[17px] font-normal "
        }`}
      >
        <div className="min-h-[64px]">{text}</div>
      </div>
      {open ? (
        <button
          onClick={() => setOpen(false)}
          className="absolute bottom-[23px] right-[30px]"
        >
          <img src={topTranArrow} alt="" />
        </button>
      ) : (
        <button
          onClick={() => setOpen(true)}
          className="text-[#2A2D37] font-bold text-[12px] w-[114px] bg-main-green h-[26px] rounded-tl-[10px] rounded-br-[10px] absolute right-0 bottom-0"
        >
          Read More
        </button>
      )}
    </div>
  );
};

export default Post;
